import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";

function IDD() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>Intrinsic Decomposition Dataset</BlockTitle>
          {/* <BlockSubtitle>Elemental Digital Environment</BlockSubtitle> */}
        </BlockContent>
        <BlockContent>
          <BlockText>The Interior Decomposition Dataset (IDD) is a dataset designed to analyze how intrinsic scene properties influence the perceived quality of color transfer methods. It consists of photorealistic, synthetically rendered indoor scenes with systematically controlled variations in color, illumination, geometry, object arrangement, and viewpoint. In addition to the rendered images, the dataset provides detailed ground-truth information such as semantic segmentation, depth, and physically-based rendering passes.</BlockText>
        </BlockContent>
      </Block>



      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
          <BlockText>
          <ul>
              <li>The dataset consists of 4 photorealistic indoor scenes with systematically controlled variations.</li>
              <li>Each scene is provided in 4 different color configurations, 8 distinct illumination settings, 4 different object arrangements, and 6 camera viewpoints.</li>
              <li>In total, the dataset contains 3,072 unique scene instances.</li>
              <li>All images are stored at a resolution of 1024 × 1024 pixels in 32-bit floating-point EXR format using a linear RGB color space.</li>
              <li>Each scene instance includes a semantic map with 26 channels representing object classes using soft assignments.</li>
              <li>Depth maps are provided with values ranging from 0 to 15 meters, normalized to the interval [0, 1].</li>
              <li>Normal maps are available in both world-space and view-space representations.</li>
              <li>Pixel size maps encode the estimated real-world surface area covered by each pixel based on depth and viewing angle.</li>
              <li>A beauty pass decomposition is included, consisting of 14 rendering channels such as diffuse and reflection components.</li>
              <li>The rendered images are released under a Creative Commons CC BY-NC 4.0 license, while the original 3D models are not included.</li>
          </ul>
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage shadow={false} src={process.env.PUBLIC_URL + '/images/projects/IDD_scenes.webp'} title="Figure 1: Scene variations"/>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
              <BlockImage shadow={false} src={process.env.PUBLIC_URL + '/images/projects/ICIP_Variations.webp'} title="Figure 2: Extract from the IDD: base scene, with variations in color statistics (top left to right), illumination, object arrangement, and view (bottom left to right)."/>
        </BlockContent>
        <BlockContent>
              <BlockImage shadow={false} src={process.env.PUBLIC_URL + '/images/projects/ICIP_Cues.webp'} title="Figure 3: Illustration of scene cues for color transfer: semantic map, size map, diffuse pass (left to right)."/>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="400px 400px 400px">
      <BlockContent textAlign="center" color="grey" fontStyle="italic">
        <BlockButton onClick={() => window.open('https://potechius.com/IDD-Viewer')}>Visualizer</BlockButton>
      </BlockContent>
      <BlockContent textAlign="center" color="grey" fontStyle="italic">
        <BlockButton onClick={() => window.open('https://potechius.com/ICIP2026ColorTransfer')}>Suppl.</BlockButton>
      </BlockContent>
      <BlockContent textAlign="center" color="grey" fontStyle="italic">
        <BlockButton onClick={() => window.open('https://huggingface.co/datasets/hpotechius/IntrinsicDecompositionDataset')}>Download</BlockButton>
        </BlockContent>
      </Block>


      <Footer/>
    </div>
  );
}

export default IDD;